import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ChatBubbleDotIcon = (props: IconProps) => (
  <Icon w="18px" h="18px" viewBox="0 0 18 18" {...props}>
    <path d="M14.25 8.625V11.925C14.25 12.6262 13.6763 13.2 12.975 13.2H4.05L1.5 15.75V4.275C1.5 3.57375 2.07375 3 2.775 3H8.89969C8.86144 3.204 8.83594 3.42075 8.83594 3.6375C8.83594 3.85425 8.86144 4.071 8.89969 4.275H2.775V11.925H12.975V8.625C13.5 8.625 13.5 8.625 14.25 8.625Z" />
    <path d="M14.25 6.75C12.59 6.75 11.25 5.41 11.25 3.75C11.25 2.09 12.59 0.75 14.25 0.75C15.91 0.75 17.25 2.09 17.25 3.75C17.25 5.41 15.91 6.75 14.25 6.75Z" />
  </Icon>
);

export default memo(ChatBubbleDotIcon);
